if (!customElements.get('spp-cart-rewards')) {
  customElements.define(
    'spp-cart-rewards',
    class extends HTMLElement {
      constructor() {
        super();

        this.requestId = 0;
        this.controller = null;
        this.refresh = this.refresh.bind(this);
      }

            connectedCallback() {
        this.hidden = true;

        document.addEventListener(
          'theme:cart:change',
          this.refresh
        );

        this.refresh();
      }

      disconnectedCallback() {
        this.requestId += 1;
        this.controller?.abort();

        document.removeEventListener(
          'theme:cart:change',
          this.refresh
        );
      }

      async refresh() {
        const requestId = ++this.requestId;

        this.controller?.abort();

        const controller = new AbortController();
        this.controller = controller;

        const root = window.Shopify?.routes?.root || '/';

        try {
          const response = await fetch(`${root}cart.js`, {
            credentials: 'same-origin',
            cache: 'no-store',
            signal: controller.signal
          });

          if (!response.ok) return;

          const cart = await response.json();

          if (!this.isConnected || requestId !== this.requestId) {
            return;
          }

                    const qualifyingTotal = cart.items.reduce(
            (total, item) => {
              const properties = item.properties || {};

              const isGift =
                Object.prototype.hasOwnProperty.call(
                  properties,
                  '_Gifted'
                );

              if (isGift) return total;

              return total + Number(item.original_line_price);
            },
            0
          );

          this.render(qualifyingTotal);
        } catch {
          // Keep the existing display if the request fails.
        }
      }

      render(total) {
        if (!Number.isFinite(total)) return;

        // Free delivery only: one milestone at the end of the bar
        const single = this.dataset.single === 'true';

        const storeCurrency = this.dataset.storeCurrency;

        const currency =
          window.Shopify?.currency?.active ||
          this.dataset.currency ||
          storeCurrency;

        const rate =
          currency === storeCurrency
            ? 1
            : Number(window.Shopify?.currency?.rate);

        if (!Number.isFinite(rate) || rate <= 0) {
          this.hidden = true;
          return;
        }

        const shippingThreshold = Math.round(
          Number(this.dataset.shippingThreshold) * rate
        );

        const rewardThreshold = single
          ? shippingThreshold
          : Math.round(Number(this.dataset.rewardThreshold) * rate);

        if (
          !Number.isFinite(shippingThreshold) ||
          !Number.isFinite(rewardThreshold) ||
          shippingThreshold <= 0 ||
          (!single && rewardThreshold <= shippingThreshold)
        ) {
          this.hidden = true;
          return;
        }

        const formatter = new Intl.NumberFormat(
          document.documentElement.lang || 'en-GB',
          {
            style: 'currency',
            currency,
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
          }
        );

        const money = (amount) =>
          formatter.format(Math.max(0, amount) / 100);

        const shippingEarned = total >= shippingThreshold;
        const rewardEarned = total >= rewardThreshold;

        const rewardName =
          this.querySelector('[data-reward-label] > span')
            ?.textContent.trim() || 'your extra reward';

        let message;

        if (single && shippingEarned) {
          message =
            this.dataset.successMessage ||
            'You’ve unlocked FREE delivery!';
        } else if (rewardEarned) {
          message =
            this.dataset.successMessage ||
            `You’ve unlocked FREE delivery and ${rewardName}!`;
        } else if (shippingEarned) {
          const template =
            this.dataset.rewardMessage ||
            `FREE delivery unlocked! Spend ||amount|| more for ${rewardName}.`;

          message = template
            .split('||amount||')
            .join(money(rewardThreshold - total));
        } else {
          const template =
            this.dataset.shippingMessage ||
            'Spend ||amount|| more for FREE delivery.';

          message = template
            .split('||amount||')
            .join(money(shippingThreshold - total));
        }

        const percent = Math.min(
          100,
          Math.max(0, (total / rewardThreshold) * 100)
        );

        this.querySelector('[data-rewards-message]')
          .textContent = message;

        this.querySelector('[data-rewards-fill]')
          .style.width = `${percent}%`;

        const progress = this.querySelector(
          '[data-rewards-progress]'
        );

        progress.setAttribute(
          'aria-valuenow',
          String(Math.round(percent))
        );

        progress.setAttribute('aria-valuetext', message);

        this.querySelector('[data-shipping-marker]')
          ?.classList.toggle('is-earned', shippingEarned);

        this.querySelector('[data-reward-marker]')
          ?.classList.toggle('is-earned', rewardEarned);

        this.querySelector('[data-shipping-label]')
          ?.classList.toggle('is-earned', shippingEarned);

        this.querySelector('[data-reward-label]')
          ?.classList.toggle('is-earned', rewardEarned);

        const shippingAmount = this.querySelector('[data-shipping-amount]');
        if (shippingAmount) shippingAmount.textContent = money(shippingThreshold);

        const rewardAmount = this.querySelector('[data-reward-amount]');
        if (rewardAmount) rewardAmount.textContent = money(rewardThreshold);

        this.style.setProperty(
          '--shipping-marker',
          `${(shippingThreshold / rewardThreshold) * 100}%`
        );

        this.hidden = false;
      }
    }
  );
}
